import axios from "axios";
import { Message } from "element-ui";
import router from "../router";

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 60000
});

function isAuthLoginRequest(config) {
  const url = String(config?.url || "");
  return url.includes("/auth/login");
}

request.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

request.interceptors.response.use(
  (resp) => {
    const body = resp.data;
    const isLogin = isAuthLoginRequest(resp?.config);

    if (typeof body?.code === "number" && body.code !== 0) {
      const message = String(body?.message || "");
      if (!isLogin && (body.code === 401 || message.includes("token") || message.includes("Token") || message.includes("认证"))) {
        handleTokenExpired();
        return Promise.reject(body);
      }
      Message.error(body.message || "请求失败");
      return Promise.reject(body);
    }

    if (typeof body?.status === "string" && body.status !== "success") {
      if (!isLogin && resp?.status === 401) {
        handleTokenExpired();
        return Promise.reject(body);
      }
      Message.error(body.message || "请求失败");
      return Promise.reject(body);
    }

    return body?.data !== undefined ? body.data : body;
  },
  (err) => {
    const isLogin = isAuthLoginRequest(err?.config);
    if (!isLogin && err?.response?.status === 401) {
      handleTokenExpired();
      return Promise.reject(err);
    }
    Message.error(err?.response?.data?.message || "网络异常，请检查服务是否启动");
    return Promise.reject(err);
  }
);

function handleTokenExpired() {
  localStorage.removeItem("token");
  localStorage.removeItem("username");
  localStorage.removeItem("is_admin");
  localStorage.removeItem("auth_user");

  Message.error("登录已过期，请重新登录");

  if (router.currentRoute.path !== "/login") {
    router.push("/login");
  }
}

export default request;
